import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { serverUrl } from '../../../Constant/Static/config';
import DeleteIcon from '../../../Constant/Icons/delete.svg';
import editIcon from '../../../Constant/Icons/edit.svg';
import saveIcon from '../../../Constant/Icons/save.svg';
import cancelIcon from '../../../Constant/Icons/cancel.svg';
import addIcon from '../../../Constant/Icons/addItem.svg';

function HandleFAQ() {
    const [faqs, setFaqs] = useState([]);
    const [newQuestion, setNewQuestion] = useState('');
    const [newAnswer, setNewAnswer] = useState('');
    const [editId, setEditId] = useState(null);
    const [editQuestion, setEditQuestion] = useState('');
    const [editAnswer, setEditAnswer] = useState('');

    const fetchFaqs = async () => {
        try {
            const response = await axios.get(`${serverUrl}/api/admin/services/faqs`);
            setFaqs(response.data);
        } catch (error) {
            console.error('Error fetching FAQs:', error);
        }
    };

    const handleAddFaq = async () => {
        try {
            const response = await axios.post(`${serverUrl}/api/admin/services/faqs`, {
                question: newQuestion,
                answer: newAnswer
            });
            setFaqs([...faqs, response.data]);
            setNewQuestion('');
            setNewAnswer('');
        } catch (error) {
            console.error('Error adding FAQ:', error);
        }
    };

    const handleEditFaq = (id, question, answer) => {
        setEditId(id);
        setEditQuestion(question);
        setEditAnswer(answer);
    };

    const handleUpdateFaq = async () => {
        try {
            const response = await axios.put(`${serverUrl}/api/admin/services/faqs/${editId}`, {
                question: editQuestion,
                answer: editAnswer
            });
            setFaqs(faqs.map(f => (f.id === editId ? response.data : f)));
            setEditId(null);
            setEditQuestion('');
            setEditAnswer('');
        } catch (error) {
            console.error('Error updating FAQ:', error);
        }
    };

    const handleDeleteFaq = async (id) => {
        try {
            await axios.delete(`${serverUrl}/api/admin/services/faqs/${id}`);
            setFaqs(faqs.filter(f => f.id !== id));
        } catch (error) {
            console.error('Error deleting FAQ:', error);
        }
    };

    useEffect(() => {
        fetchFaqs();
    }, []);

    return (
        <>
            <h2 className="faq-heading">Manage FAQs</h2>
            <div className="faq-list-container">
                <ul className="faq-list">
                    {faqs.map(faq => (
                        <li key={faq.id} className="faq-item">
                            {editId === faq.id ? (
                                <div className="faq-edit-mode">
                                    <div>
                                        <label>
                                            <strong>Q:</strong>
                                            <input
                                                type="text"
                                                value={editQuestion}
                                                onChange={(e) => setEditQuestion(e.target.value)}
                                                placeholder="Edit question"
                                            />
                                        </label>
                                        <label>
                                            <strong>A:</strong>
                                            <input
                                                type="text"
                                                value={editAnswer}
                                                onChange={(e) => setEditAnswer(e.target.value)}
                                                placeholder="Edit answer"
                                            />
                                        </label>
                                    </div>
                                    <div className="faq-button-group">
                                        <button className="faq-save-btn" onClick={handleUpdateFaq}>
                                            <img src={saveIcon} alt='save' width={20} height={20} />
                                        </button>
                                        <button className="faq-cancel-btn" onClick={() => setEditId(null)}>
                                            <img src={cancelIcon} alt='cancel' width={20} height={20} />
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                <div className="faq-view-mode">
                                    <div className="faq-content">
                                        <span>
                                            <strong>Q:</strong> {faq.question.length > 45 ? `${faq.question.slice(0, 40)}...` : faq.question} <br />
                                            <strong>A:</strong> {faq.answer.length > 45 ? `${faq.answer.slice(0, 40)}...` : faq.answer}
                                        </span>
                                    </div>
                                    <div className="faq-button-group">
                                        <button className="faq-edit-btn" onClick={() => handleEditFaq(faq.id, faq.question, faq.answer)}>
                                            <img src={editIcon} alt='edit' width={20} height={20} />
                                        </button>
                                        <button className="faq-delete-btn" onClick={() => handleDeleteFaq(faq.id)}>
                                            <img src={DeleteIcon} alt='delete' width={20} height={20} />
                                        </button>
                                    </div>
                                </div>
                            )}
                        </li>
                    ))}
                </ul>
            </div>
            <div className="faq-input-container">
                <input
                    type="text"
                    value={newQuestion}
                    onChange={(e) => setNewQuestion(e.target.value)}
                    placeholder="New FAQ Question"
                    className="faq-input"
                />
                <input
                    type="text"
                    value={newAnswer}
                    onChange={(e) => setNewAnswer(e.target.value)}
                    placeholder="New FAQ Answer"
                    className="faq-input"
                />
                <button className="faq-add-btn" onClick={handleAddFaq}>
                    <img src={addIcon} alt='add' width={20} height={20} />
                </button>
            </div>
        </>
    );
};

export default HandleFAQ;